import Subheader from 'app/frontend/base/components/Subheader'
import {
  usePageInfo,
  useUserApplicationSummary,
} from 'app/frontend/base/config/queries'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'
import { useTranslation } from 'react-i18next'

const UserSubheader = () => {
  const { t } = useTranslation()
  const { customDomain } = useCustomDomain()
  const {
    data: { user, gameVersion },
  } = usePageInfo()

  const { data: applicationSummary, isPending } = useUserApplicationSummary()

  if (!user) return null

  return (
    <Subheader
      menuItems={[
        {
          name: t('profile.header.linked-accounts'),
          path: `/profile`,
          exact: true,
          width: 140,
        },
        {
          name: t('profile.header.characters'),
          path: `/profile/characters`,
          width: 105,
        },
        {
          name: t('profile.header.premium'),
          path: `/profile/premium`,
          width: 90,
        },
        {
          name: t('profile.header.events'),
          path: `/profile/events`,
          width: 80,
        },
        ...(gameVersion === 'live'
          ? [
              {
                name: t('profile.header.plans'),
                path: `/profile/plans`,
                width: 101,
              },
            ]
          : []),
        ...(customDomain
          ? []
          : [
              {
                name: (
                  <div
                    className={`flex items-center justify-center gap-1.5 md:w-26 ${
                      isPending ? 'opacity-0' : 'opacity-100'
                    }`}
                  >
                    <span>{t('profile.header.applications')}</span>
                    <span className='text-muted-foreground text-xs max-md:hidden'>
                      ({Object.keys(applicationSummary ?? {}).length ?? 0})
                    </span>
                  </div>
                ),
                path: `/profile/applications`,
                width: 136,
              },
            ]),
        {
          name: t('profile.header.settings'),
          path: `/profile/settings`,
          width: 87,
        },
      ]}
    />
  )
}

export default UserSubheader
